import React from 'react';
import {AbroadPackageModel, PackageDetails, PackageType, UnitMeasureCodeOptionsFeature} from '../Models/AbroadPackageModels';
import {getDataUsageDisplay} from '../../cellcomAbroadUtilities';
import '../Sass/AbroadDifferentTarifTab.scss';

interface AbroadDifferentTarifTabProps {
  packageDetailsList: PackageDetails[];
  packageData: AbroadPackageModel;
}

const detailsRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  return <div className='AbroadDifferentTarifTab__content__all-price'>{filterRenderingByUse(packageDetail, packageData)}</div>;
};

const filterRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  switch (packageData.type) {
    case PackageType.VoiceSmsData: {
      return (
        <>
          {dataRenderingByUse(packageDetail, packageData)}
          <div className='AbroadDifferentTarifTab__content__separator'></div>
          {phoneRenderingByUse(packageDetail, packageData)}
          <div className='AbroadDifferentTarifTab__content__separator'></div>
          {smsRenderingByUse(packageDetail, packageData)}
        </>
      );
    }
    case PackageType.VoiceAndSmsData: {
      return (
        <>
          {dataRenderingByUse(packageDetail, packageData)}
          <div className='AbroadDifferentTarifTab__content__separator'></div>
          {phoneAndSmsRenderingByUse(packageDetail, packageData)}
        </>
      );
    }
    case PackageType.VoiceAndSms: {
      return <>{phoneAndSmsRenderingByUse(packageDetail, packageData)}</>;
    }
    case PackageType.VoiceSms: {
      return (
        <>
          {phoneRenderingByUse(packageDetail, packageData)}
          <div className='AbroadDifferentTarifTab__content__separator'></div>
          {smsRenderingByUse(packageDetail, packageData)}
        </>
      );
    }
    case PackageType.Data: {
      return <>{dataRenderingByUse(packageDetail, packageData)}</>;
    }
    default:
      return null;
  }
};

const dataRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  const details = packageDetail;
  const dataDisplay = getDataUsageDisplay(details?.data);
  return (
    <div className='AbroadDifferentTarifTab__content__price'>
      <span>{dataDisplay.value}</span>
      <span>{dataDisplay.unit}</span> ב-{shekelOrAgourot(details.data.priceByUsage)}
      {!(
        packageData?.steppedPerDay === true && packageData?.type.toLowerCase() === "data"
        ) && (
          <>
            ב - {shekelOrAgourot(details.data.priceByUsage)}
            {details.data.unit === UnitMeasureCodeOptionsFeature.PerDay ? ' ליום' : ''}
          </>
        )}
    </div>
  );
};

const smsRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  const details = packageDetail;
  return <div className='AbroadDifferentTarifTab__content__price'>{shekelOrAgourot(details.sms.priceByUsage)} להודעה</div>;
};

const phoneRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  const details = packageDetail;
  return <div className='AbroadDifferentTarifTab__content__price'>{shekelOrAgourot(details.voice.priceByUsage)} לדקה</div>;
};

const phoneAndSmsRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  const details = packageDetail;
  return <div className='AbroadDifferentTarifTab__content__price'>{shekelOrAgourot(details.voice.priceByUsage)} לדקה/הודעה</div>;
};

const shekelOrAgourot = (price: number) => {
  if (price >= 1)
    return (
      <>
        <span>{price}</span> ₪
      </>
    );
  else
    return (
      <>
        <span>{price * 100}</span> אג'
      </>
    );
};

const AbroadDifferentTarifTab = ({packageDetailsList, packageData}: AbroadDifferentTarifTabProps) => {
  const renderPackageDetailsList = () =>
    packageDetailsList?.map((x, i) => (
      <div className='AbroadDifferentTarifTab__content' key={i}>
        <div className='AbroadDifferentTarifTab__content__state'>{x.countrySupportedList.map((y) => y.countryHebName).join(`, `)}</div>
        <>{detailsRenderingByUse(x, packageData)}</>
      </div>
    ));
  return <div className={'AbroadDifferentTarifTab'}>{renderPackageDetailsList()}</div>;
};

export default AbroadDifferentTarifTab;
